export const priceListActionTypes = {
    START_ADD_PRICE_LIST: "START_ADD_PRICE_LIST",
    ADD_PRICE_LIST_SUCCESS: "ADD_PRICE_LIST_SUCCESS",
    ADD_PRICE_LIST_FAILURE: "ADD_PRICE_LIST_FAILURE",

    START_UPDATE_PRICE_LIST: "START_UPDATE_PRICE_LIST",
    UPDATE_PRICE_LIST_SUCCESS: "UPDATE_PRICE_LIST_SUCCESS",
    UPDATE_PRICE_LIST_FAILURE: "UPDATE_PRICE_LIST_FAILURE",

    START_DELETE_PRICE_LIST: "START_DELETE_PRICE_LIST",
    DELETE_PRICE_LIST_SUCCESS: "DELETE_PRICE_LIST_SUCCESS",
    DELETE_PRICE_LIST_FAILURE: "DELETE_PRICE_LIST_FAILURE",

    START_GET_PRICE_LISTS: "START_GET_PRICE_LISTS",
    GET_PRICE_LISTS_SUCCESS: "GET_PRICE_LISTS_SUCCESS",
    GET_PRICE_LISTS_FAILURE: "GET_PRICE_LISTS_FAILURE",

    START_ADD_PRICE: "START_ADD_PRICE",
    ADD_PRICE_SUCCESS: "ADD_PRICE_SUCCESS",
    ADD_PRICE_FAILURE: "ADD_PRICE_FAILURE",

    START_UPDATE_PRICE: "START_UPDATE_PRICE",
    UPDATE_PRICE_SUCCESS: "UPDATE_PRICE_SUCCESS",
    UPDATE_PRICE_FAILURE: "UPDATE_PRICE_FAILURE",
};
